import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { User } from './models/user';
import { UserService } from './services/user.service';
import { SvgIconComponent } from '../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { SelectionChangedEvent } from 'devextreme/ui/data_grid';

@Component({
    templateUrl: './user-search.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, DxDataGridModule, BizDataGridDirective, DxTemplateModule]
})
export class UserSearchComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly userService = inject(UserService);

    public isLoading: boolean = false;
    public users: User[];
    public selectedUsers: User[] = [];

    ngOnInit(): void {
        void this.refresh();
    }

    async refresh(): Promise<void> {
        this.isLoading = true;
        try {
            this.users = await this.userService.getUsersForPresentation();
        }
        finally {
            this.isLoading = false;
        }
    }

    public rowDoubleClicked(_user: User): void {
        void this.showUsers();
    }

    public selectionChanged(event: SelectionChangedEvent<User>): void {
        this.selectedUsers = event.selectedRowsData;
    }

    async showUsers(): Promise<boolean> {
        const userIds = this.selectedUsers.map((p) => p.UserId);
        return await this.router.navigate(['user/details', { userIds: userIds.join(',') }]);
    }

    async newUser(): Promise<boolean> {
        return await this.router.navigate(['user/details', { createNew: true }]);
    }
}
